import { NBuilderConfig } from '../common/builder.config';
import { NBuilderProductsSetup } from '../common/products-setup/builder-products-setup.config';
import { IStepSelection } from '../common/simple-step/simple-step.component';
import { NOutfitGeneralSetup } from './general-setup/outfit-general-setup.config';

export namespace NOutfitBuilder {
    export const typeId = 'outfit-builder';
    export enum EConfigureOptions {
        rider = 'Rider',
        horse = 'Horse',
        riderAndHorse = 'Rider & Horse'
    }
    export enum ESteps {
        configure,
        rider,
        horse,
        products
    }
    export const STEPS_CONFIG = {
        [EConfigureOptions.rider]: [ESteps.configure, ESteps.rider, ESteps.products],
        [EConfigureOptions.horse]: [ESteps.configure, ESteps.horse, ESteps.products],
        [EConfigureOptions.riderAndHorse]: [ESteps.configure, ESteps.rider, ESteps.horse, ESteps.products]
    };
    export interface IPageData extends NOutfitGeneralSetup.IGeneralSetupData, NBuilderProductsSetup.IProductsSetupData {
        title: string;
        leftSectionRider: NBuilderProductsSetup.ILeftSectionElement[];
        leftSectionHorse: NBuilderProductsSetup.ILeftSectionElement[];
    }
    export interface IStorageData extends NBuilderConfig.IStorageData {
        step: ESteps | -1;
        configOption?: EConfigureOptions;
        rider?: IStepSelection;
        horse?: IStepSelection;
        optionToggleState?: NBuilderProductsSetup.EToggleOptions;
    }
}
